import React, { useEffect, useState, useCallback } from "react";
import ActivityIndicator from "../components/ActivityIndicator";
import configurationPost from "../config/configurationPost";
import connectionConfig from "../config/settings";
import { View, StyleSheet, Image, Dimensions, 
         FlatList, Alert, TouchableOpacity, Text,
         Platform, ScrollView } from 'react-native';
import { Image as ImageCache } from "react-native-expo-image-cache";
import routes from "../navigation/routes";
import { useFocusEffect } from '@react-navigation/native';
import { Video, AVPlaybackStatus } from 'expo-av';
import { Foundation } from "@expo/vector-icons";
import colors from "../config/colors";

var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;

var pointer = 0
var blockSize = 100
var pageNumber = 0
var arraySeeds = []
var webUrl = connectionConfig.imageUrl + '/seedImages/'
var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'


function MosaicFixoSeeds(props) {
  //function MosaicOfSeedsScreen({navigation, userId}) {
  const [seedsSucces, setSeedsSucces] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const video = React.useRef(null);
  const [status, setStatus] = useState({});
  var foundUserChecker = props.foundUserChecker;


  useFocusEffect(
    useCallback(() => {
      pageNumber = 0
      arraySeeds = []
      getSeeds();
    }, [])    // [props.userId]
  );

  const getSeeds = async () => {
    //debugger
    pointer = pageNumber * blockSize
    setLoading(true)
    var post_values = {
      //userId : userId
      userId: 111,
      pointer: pointer,
      blockSize: blockSize
    }
    //establece parámetros de configurción del post
    configurationPost.body = JSON.stringify(post_values)
    //solicita el servicio para adquirir los pubicaciones del servidor
    await fetch(connectionConfig.apiUrl + '/selectMosaicSeed/', configurationPost)
      .then(response => response.json())
      .then(response => {
        //if(response.data.length === 0)
        if (response.data.length === 0) {
          if (pageNumber > 0) {
            setLoading(false)
          } else {
            setSeedsSucces(false)
            setLoading(false)
          }
        } else {
          pageNumber++
          if (arraySeeds.length > 0) {
            arraySeeds = [...arraySeeds, ...response.data]
            //arraySeeds = [ ...arraySeeds, ...response]
          } else {
            arraySeeds = response.data
            //arraySeeds = response
          }
          setItems(arraySeeds)
          setLoading(false)
          setSeedsSucces(true)
        }
      })
      .catch(err => {
        console.log('getSeeds failed :( review internet service)', err)
      })
  }



  return (
    <View style={{flex: 1, backgroundColor: colors.fondoGeneral}}>
    {/* <> */}
      <ActivityIndicator visible={loading} />
      { (Platform.OS === 'web') ? 
      seedsSucces ?
        <FlatList
          style={styles.imageContainer}
          data={items}
          keyExtractor={(item) => item.seedId.toString()}
          //key={String(items.seedId)}
          //keyExtractor={item => String(item.seedId) }
          numColumns={3}
          initialNumToRender={items.length}
          //onEndReachedThreshold={-0.5}
          onEndReachedThreshold={.5}
          onEndReached={() => getSeeds()}
          renderItem={({ item, index }) => (
            <TouchableOpacity onPress={() => {
              var userId = props.userId
              props.navigation.navigate(routes.LISTINGS_SEEDS, {
                items,
                index,
                pointer,
                blockSize,
                pageNumber,
                foundUserChecker,
                userId
              })

            }}  >
               
              {item.seedPhoto.includes('.mp4') ?
                <Video
                  ref={video}
                  style={item.type === 0 ? styles.image :
                    item.type === 1 ? styles.image1 :
                      item.type === 2 ? styles.image2 :
                        item.type === 3 ? styles.image3 :
                          item.type === 4 ? styles.image4 :
                            item.type === 5 ? styles.image5 :
                              item.type === 6 ? styles.image6 :
                                item.type === 7 ? styles.image7 :
                                  item.type === 8 ? styles.image8 :
                                    styles.image9
                  }
                  source={{
                    uri: seedVideoUri + item.seedPhoto
                  }}
                  //useNativeControls
                  resizeMode="contain"
                //isLooping
                //onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                :
                item.seedPhoto.includes('.mov') ?
                  <Video
                    ref={video}
                    style={item.type === 0 ? styles.image :
                      item.type === 1 ? styles.image1 :
                        item.type === 2 ? styles.image2 :
                          item.type === 3 ? styles.image3 :
                            item.type === 4 ? styles.image4 :
                              item.type === 5 ? styles.image5 :
                                item.type === 6 ? styles.image6 :
                                  item.type === 7 ? styles.image7 :
                                    item.type === 8 ? styles.image8 :
                                      styles.image9
                    }
                    source={{
                      uri: seedVideoUri + item.seedPhoto
                    }}
                    //useNativeControls
                    resizeMode="contain"
                  //isLooping
                  //onPlaybackStatusUpdate = {status => setStatus(() => status)}
                  />
                  :
                  item.seedPhoto === '' ?
                    <Foundation //style={styles.image}
                      style={item.type === 0 ? styles.image :
                        item.type === 1 ? styles.image1 :
                          item.type === 2 ? styles.image2 :
                            item.type === 3 ? styles.image3 :
                              item.type === 4 ? styles.image4 :
                                item.type === 5 ? styles.image5 :
                                  item.type === 6 ? styles.image6 :
                                    item.type === 7 ? styles.image7 :
                                      item.type === 8 ? styles.image8 :
                                        styles.image9
                      }
                      name="mountains"
                      size={120}
                      color={colors.medium} />
                  :
                  <View style={styles.viewImage}> 
                        <Image
                          //debugger
                          //style= {styles.image}
                          style={item.type === 0 ? styles.image :
                            item.type === 1 ? styles.image1 :
                              item.type === 2 ? styles.image2 :
                                item.type === 3 ? styles.image3 :
                                  item.type === 4 ? styles.image4 :
                                    item.type === 5 ? styles.image5 :
                                      item.type === 6 ? styles.image6 :
                                        item.type === 7 ? styles.image7 :
                                          item.type === 8 ? styles.image8 :
                                            styles.image9
                          }
                          source={{ uri: webUrl + item.seedPhoto }}
                          resizeMode="contain"
                        />
                  </View>
                  }
              
            </TouchableOpacity>
          )}
        />
        :
        <Text>This user has not seeds yet.  :) </Text>
      :
      null
    }

     { (Platform.OS === 'ios') ? 
      seedsSucces ?
        <FlatList
          style={styles.imageContainer}
          data={items}
          keyExtractor={(item) => item.seedId.toString()}
          //key={String(items.seedId)}
          //keyExtractor={item => String(item.seedId) }
          numColumns={3}
          initialNumToRender={items.length}
          //onEndReachedThreshold={-0.5}
          onEndReachedThreshold={.5}
          onEndReached={() => getSeeds()}
          renderItem={({ item, index }) => (
            <TouchableOpacity onPress={() => {
              var userId = props.userId
              props.navigation.navigate(routes.LISTINGS_SEEDS, {
                items,
                index,
                pointer,
                blockSize,
                pageNumber,
                foundUserChecker,
                userId
              })

            }}  >
               
              {item.seedPhoto.includes('.mp4') ?
                <Video
                  ref={video}
                  style={item.type === 0 ? styles.image :
                    item.type === 1 ? styles.image1 :
                      item.type === 2 ? styles.image2 :
                        item.type === 3 ? styles.image3 :
                          item.type === 4 ? styles.image4 :
                            item.type === 5 ? styles.image5 :
                              item.type === 6 ? styles.image6 :
                                item.type === 7 ? styles.image7 :
                                  item.type === 8 ? styles.image8 :
                                    styles.image9
                  }
                  source={{
                    uri: seedVideoUri + item.seedPhoto
                  }}
                  //useNativeControls
                  resizeMode="contain"
                //isLooping
                //onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                :
                item.seedPhoto.includes('.mov') ?
                  <Video
                    ref={video}
                    style={item.type === 0 ? styles.image :
                      item.type === 1 ? styles.image1 :
                        item.type === 2 ? styles.image2 :
                          item.type === 3 ? styles.image3 :
                            item.type === 4 ? styles.image4 :
                              item.type === 5 ? styles.image5 :
                                item.type === 6 ? styles.image6 :
                                  item.type === 7 ? styles.image7 :
                                    item.type === 8 ? styles.image8 :
                                      styles.image9
                    }
                    source={{
                      uri: seedVideoUri + item.seedPhoto
                    }}
                    //useNativeControls
                    resizeMode="contain"
                  //isLooping
                  //onPlaybackStatusUpdate = {status => setStatus(() => status)}
                  />
                  :
                  item.seedPhoto === '' ?
                    <Foundation //style={styles.image}
                      style={item.type === 0 ? styles.image :
                        item.type === 1 ? styles.image1 :
                          item.type === 2 ? styles.image2 :
                            item.type === 3 ? styles.image3 :
                              item.type === 4 ? styles.image4 :
                                item.type === 5 ? styles.image5 :
                                  item.type === 6 ? styles.image6 :
                                    item.type === 7 ? styles.image7 :
                                      item.type === 8 ? styles.image8 :
                                        styles.image9
                      }
                      name="mountains"
                      size={120}
                      color={colors.medium} />
                  :
                    <View style={styles.viewImage}>
                        <ImageCache
                          //debugger
                          //= {styles.image}
                          style={item.type === 0 ? styles.image :
                            item.type === 1 ? styles.image1 :
                              item.type === 2 ? styles.image2 :
                                item.type === 3 ? styles.image3 :
                                  item.type === 4 ? styles.image4 :
                                    item.type === 5 ? styles.image5 :
                                      item.type === 6 ? styles.image6 :
                                        item.type === 7 ? styles.image7 :
                                          item.type === 8 ? styles.image8 :
                                            styles.image9
                          }
                          //source={{ uri: webUrl + item.seedPhoto }}
                          uri= { webUrl + item.seedPhoto }
                          resizeMode="contain"
                        ></ImageCache>
                    </View>
                  }
              
            </TouchableOpacity>
          )}
        />
        :
        <Text>This user has not seeds yet.  :) </Text>
      :
      null
    }
    {/* </> */}
   </View>
  );
}

const styles = StyleSheet.create({
  imageContainer: {
    marginVertical: '1%',
    marginLeft: (windowWidth * .01), //'2%',
    alignContent: 'center',
    width: windowWidth,  //'100%',
    height: windowHeight,     //'100%',
    backgroundColor: colors.fondoGeneral
  },
  image: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 5,
    borderColor: colors.fuente,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image1: {
    margin: "0.5%",
    width: colors.imageInMosaic, //120,
    height: colors.imageInMosaic, //120,
    borderWidth: 4,
    borderColor: colors.chakra1nar,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",  
    },
  image2: {
    margin: "0.5%",
    width: colors.imageInMosaic, //120,
    height: colors.imageInMosaic, 
    borderWidth: 4,
    borderColor: colors.chakra2ama,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image3: {
    margin: "0.5%",
    width: colors.imageInMosaic, //120,
    height: colors.imageInMosaic, //120,
    borderWidth: 4,
    borderColor: colors.chakra3ver,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image4: {
    margin: "0.5%",
    width: colors.imageInMosaic, //120,
    height: colors.imageInMosaic, //120,
    borderWidth: 4,
    borderColor: colors.chakra4azu,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image5: {
    margin: "0.5%",
    width: colors.imageInMosaic, //120,
    height: colors.imageInMosaic, //120,
    borderWidth: 4,
    borderColor: colors.chakra5vlt,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image6: {
    margin: "0.5%",
    width: colors.imageInMosaic, //120,
    height: colors.imageInMosaic, //120,
    borderWidth: 4,
    borderColor: colors.chakra6rsa,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image7: {
    margin: "0.5%",
    width: colors.imageInMosaic,  //120,
    height: colors.imageInMosaic, //120,
    borderWidth: 4,
    borderColor: colors.chakra7ryo,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image8: {
    margin: "0.5%",
    width: colors.imageInMosaic, //120,
    height: colors.imageInMosaic, //120,
    borderWidth: 4,
    borderColor: colors.chakra8tur,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image9: {
    margin: "0.5%",
    width: colors.imageInMosaic, //120,
    height: colors.imageInMosaic, //120,
    borderWidth: 4,
    borderColor: colors.chakra9aur,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  viewImage: {
    margin: "0.5%",
    width: colors.imageInMosaic, //120,
    height: colors.imageInMosaic, //120,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.fondoImagenes
  }
})

export default MosaicFixoSeeds;